import { useEffect } from 'react';

/**
 * Hook to lock/unlock body scroll when modal is open
 * Prevents background scrolling on mobile devices
 */
export const useBodyScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (isLocked) {
      const originalStyle = {
        overflow: document.body.style.overflow,
        overflowX: document.body.style.overflowX,
        overflowY: document.body.style.overflowY,
      };

      // Lock body scroll (avoid touch-action:none so inner modals can still scroll on iOS)
      document.body.style.overflow = 'hidden';
      document.body.style.overflowX = 'hidden';
      document.body.style.overflowY = 'hidden';

      const html = document.documentElement;
      const originalHtmlStyle = {
        overflow: html.style.overflow,
        overflowX: html.style.overflowX,
        overflowY: html.style.overflowY,
      };
      html.style.overflow = 'hidden';
      html.style.overflowX = 'hidden';
      html.style.overflowY = 'hidden';

      return () => {
        document.body.style.overflow = originalStyle.overflow || '';
        document.body.style.overflowX = originalStyle.overflowX || '';
        document.body.style.overflowY = originalStyle.overflowY || '';

        html.style.overflow = originalHtmlStyle.overflow || '';
        html.style.overflowX = originalHtmlStyle.overflowX || '';
        html.style.overflowY = originalHtmlStyle.overflowY || '';
      };
    }
  }, [isLocked]);
};

